import { dateOf, esc } from './sbchart.ts';

type Data = Record<string, any>;
const date = (d: unknown) => typeof d === 'number' && Number.isSafeInteger(d) && d >= 0 ? dateOf(d) : '未记录';
const days = (n: unknown) => typeof n === 'number' && Number.isFinite(n) && n >= 0 ? `${n} 天` : '未记录';
const known = (v: unknown) => typeof v === 'string' && v ? v : '未记录';
const row = (label: string, value: string) => `<div class="sb-row"><span>${esc(label)}</span><b>${value}</b></div>`;
const qualification = (c: Data | null | undefined) => !c ? '未提供院内资格登记'
  : c.specialist === true ? '专家' : c.qualified === true ? '医生' : c.qualified === false ? '受监督培训' : '资格判定未提供';
const scope = '培训和执业进度可能包含建城前或迁入时登记的既有资历，未分开保存其本城累计；不能据此还原本城带教地点、取得资格日或逐日执业经历。医学学历的登记日也不自动等于本城毕业日。';

/** 只路由到同一个稳定人物，不为医院名单额外请求每人的详情。 */
export function clinicianCareerLinks(who: Data | null | undefined): string {
  if (!Number.isSafeInteger(who?.id) || who!.id < 0) return '人物编号未记录';
  return `<a data-go="person:${who!.id}" data-view="education">看医学培养</a> · <a data-go="person:${who!.id}" data-view="employment">任职与工资</a>`;
}

/** clinician进度允许由既有资历初始化；只有Degree.attended明确记录本城实际到课。 */
export function clinicianCareerHTML(a: Data | null | undefined, school: (f: Data) => string): string {
  const degree = a?.medicine, c = a?.clinician;
  if (!degree && !c) return '';
  const source = degree ? known(degree.source) : '未提供医学学历登记，不能从医务资格倒推学历';
  return '<section class="sb-sec"><h4>医学培养与执业登记</h4>' +
    row('当前医务资格', esc(qualification(c))) + row('医学学历来源', esc(source)) +
    row('学历登记 / 取得日', degree ? date(degree.day) : '未记录') +
    row('登记学校', degree?.school ? school(degree.school) : '未记录') +
    row('该医学学历记录的本城到课', degree ? days(degree.attended) : '未记录') +
    row('登记培训进度', days(c?.trainingDays)) + row('登记执业进度', days(c?.practiceDays)) +
    `<p class="meta">${esc(scope)}</p></section>`;
}

/** 人可读正文补上同一现有快照；不新增病历、学位、训练事件或改原始JSON。 */
export function clinicianCareerText(a: Data | null | undefined): string[] {
  const degree = a?.medicine, c = a?.clinician;
  if (!degree && !c) return [];
  const school = degree?.school;
  return ['医学培养与执业登记（当前快照）', `当前医务资格：${qualification(c)}`,
    `医学学历来源：${degree ? known(degree.source) : '未提供，不能从医务资格倒推学历'}`,
    `学历登记 / 取得日：${degree ? date(degree.day) : '未记录'}`,
    `登记学校：${school ? `${known(school.name)}${Number.isSafeInteger(school.id) && school.id >= 0 ? ` · 学校 #${school.id}` : ' · 学校编号未记录'}` : '未记录'}`,
    `该医学学历记录的本城到课：${degree ? days(degree.attended) : '未记录'}`,
    `登记培训进度：${days(c?.trainingDays)} · 登记执业进度：${days(c?.practiceDays)}`, scope];
}
